import Vue from 'vue';

class AppEvents extends Vue {
  public static REDIRECT_TO_FRONTEND = 'REDIRECT_TO_FRONTEND';
  public static SIGNOUT_FROM_APP = 'SIGNOUT_FROM_APP';
}

export default AppEvents;
